const Blog = {
  onLoad: () => {
    console.log('Hey Good Game Blog JavaScript loaded');
    const mobileNavIcon = document.getElementById('mobile-nav-icon');
    if (mobileNavIcon) {
      mobileNavIcon.addEventListener('click', function (e) {
        e.preventDefault();

        const mobileMenu = document.getElementById('mobile-menu');
        if (mobileMenu) {
          mobileMenu.style.display = 'block';
        }
        document.body.classList.add('showing-mobile-menu');

        var themeMeta = document.createElement('meta');
        themeMeta.name = 'theme-color';
        themeMeta.content = '#fff';
        themeMeta.id = 'theme-meta';
        document.getElementsByTagName('head')[0].appendChild(themeMeta);
      });
    }

    const closeButton = document.getElementById('close-mobile-menu-button');
    if (closeButton) {
      closeButton.addEventListener('click', function (e) {
        e.preventDefault();

        const mobileMenu = document.getElementById('mobile-menu');
        if (mobileMenu) {
          mobileMenu.style.display = 'none';
        }
        document.body.classList.remove('showing-mobile-menu');
        
        const themeMeta = document.getElementById('theme-meta');
        if (themeMeta) {
          themeMeta.remove();
        }
      });
    }
  },
};

export default Blog;
